import { render } from "./SpinLoader.vue?vue&type=template&id=2fc3f2a5&scoped=true"
import script from "./SpinLoader.vue?vue&type=script&lang=js"
export * from "./SpinLoader.vue?vue&type=script&lang=js"

import "./SpinLoader.vue?vue&type=style&index=0&id=2fc3f2a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc3f2a5"],['__file',"src/components/SpinLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fc3f2a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fc3f2a5', __exports__)) {
    api.reload('2fc3f2a5', __exports__)
  }
  
  module.hot.accept("./SpinLoader.vue?vue&type=template&id=2fc3f2a5&scoped=true", () => {
    api.rerender('2fc3f2a5', render)
  })

}


export default __exports__